import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600 mt-2">持续更新的白洁故事赏析与情感话题</p>
          </div>
          <Link
            to="/category/story-appreciation"
            className="text-sm text-primary-500 hover:text-primary-600 font-label transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}